import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import "../styles/contactus.css";
import { pageIds } from "../utils/contants";

export const ContactUs = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    const { from_name, from_email, message } = e.target;

    // 🔴 Validation
    if (
      !from_name.value.trim() ||
      !from_email.value.trim() ||
      !message.value.trim()
    ) {
      alert("❌ Please fill all fields");
      return;
    }

    emailjs
      .sendForm(
        "service_tvuruyp",
        "template_qn5xxdf",
        form.current,
        "fYsmEvcDI0grYVa_Z"
      )
      .then(
        () => {
          alert("✅ Mail sent successfully");
          e.target.reset();
        },
        (error) => {
          console.log(error.text);
          alert("❌ Something went wrong");
        }
      );
  };

  return (
    <div className="data" id={pageIds.contactUs}>
      <h1>Contact Us</h1>
      <form ref={form} onSubmit={sendEmail}>
        <label>Name</label>
        <input
          type="text"
          name="from_name"
          autoComplete="off"
          required
        />

        <label>Email</label>
        <input
          type="email"
          name="from_email"
          autoComplete="off"
          required
        />

        <label>Message</label>
        <textarea
          name="message"
          autoComplete="off"
          rows="4"
          required
        />

        <input type="submit" value="Send" />
      </form>
    </div>
  );
};
